<script setup>
  import { ref, onBeforeMount, computed} from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useAreasStore } from "@/stores/areas";
import { useUiStore } from "@/stores/ui";
  const company_id = useCompanyStore().companyId;
  const areasStore = useAreasStore();
  const uiStore = useUiStore();
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  const emit = defineEmits(['refresh']);
  let id = ref(null);
  let name = ref(null);
  let isSubmitted = ref(false);

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  const onSubmit = () => {
    isSubmitted.value = true;

    areasStore.deleteArea({id : id.value , companyId : company_id})
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });

  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'area' && getModalAction.value == 'delete_location'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'delete_location'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete Location </template>

    <template #body>

      <div class="delete-text mb-3">
        <span>Are you sure you want to <b>"Delete"</b> the location <b>{{ name }}</b> ?</span>
      </div>

      <p class="delete-text">Please ensure you have migrated all associated areas and devices first.</p>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  
